import React from 'react'
import { DashboardLayout } from '../layouts';
import { AgentRecordsSummary, LatestResponseSummary, ResponseChart } from '../containers';
import { CustomGoogleMap } from '../components';
import { useAuthentication } from '../../application/hooks';
import { useEffect, useState } from 'react';
import services from '../../ioc/services';


function AdminDashboard() {

    useAuthentication();

    const [places, setPlaces] = useState(null);


    useEffect(() => {
        services.api.form.getAllResponseWithLocation()
            .then(res => {
                setPlaces(res.map(response => {

                    const gpsName = response.form.fields.find(r => r.key == "gps")?.name;

                    try {

                        const location = response.responseObject[gpsName];

                        if(location == null || location == undefined || location.trim() == ''){
                            return null;
                        }

                        return ({
                            lat: location.split(",")[0],
                            lng: location.split(",")[1],
                            markerData: {
                                responseId: response._id,
                                formId: response.form_id,
                                form: response.form.title,
                                responseDate: response.createdAt,
                                agent: `${response.filledBy.firstName} ${response.filledBy.lastName}`
                            }
                        })

                    }
                    catch (err) {
                        return null;
                    }

                }))
            })
            .catch(err => { console.log(err) })
    }, [])


    return (
        <DashboardLayout>

            <div className='grid grid-cols-2 gap-5 bg-ashBg p-5 overflow-hidden' >
                <div className=' scroll-auto'>
                    <div className=' grid grid-cols-2 gap-2 min-h-[500px]'>

                        <div className='bg-white rounded-lg'>
                            <ResponseChart />
                        </div>
                        <div className='bg-white rounded-lg'>
                            <AgentRecordsSummary />
                        </div>
                    </div>

                    {/* <div className='bg-white rounded-lg mt-5'>
                        <LatestResponseSummary />
                    </div> */}
                </div>

                <div className=''>
                    {places && <CustomGoogleMap places={places} />}
                </div>

            </div>

        </DashboardLayout>
    )
}

export default AdminDashboard